import type { ContextMessage } from '../../../types/chat'

import { ContextUpdateStrategy } from '@proj-airi/server-sdk'
import { nanoid } from 'nanoid'

import { useMemoryStore } from '../../memory'

const MEMORY_CONTEXT_ID = 'memory:companion'

/**
 * Injects 云璃's long-term memory + current companion state into the chat
 * context. Reads synchronously from the memory store, which is pre-loaded by
 * the chat page on mount (and refreshed after each extraction).
 */
export function createMemoryContext(): ContextMessage | null {
  const store = useMemoryStore()
  const text = store.contextText.trim()
  if (!text)
    return null

  return {
    id: nanoid(),
    contextId: MEMORY_CONTEXT_ID,
    strategy: ContextUpdateStrategy.ReplaceSelf,
    text,
    createdAt: Date.now(),
  }
}
